import { Grid, GTIWebTextField } from "@gti-controls-v2/web-core";

const FormRecovery = ({ onChangeForm, isLoading, onBlurForm, value }) => {
    const onChange = (e) => {
        if (onChangeForm) {
            onChangeForm(e);
        }
    };

    const onBlur = (e) => {
        if (onBlurForm) {
            onBlurForm(e);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <GTIWebTextField
                    name="usernameEmail"
                    type="login"
                    disabled={isLoading}
                    value={value.usernameEmail}
                    labelText={"Correo electrónico"}
                    placeholder={"Escribe tu correo electrónico corporativo"}
                    width="100%"
                    autoFocus={true}
                    legendText={value.userLegend}
                    state={value.userState}
                    onChange={onChange}
                    onBlur={onBlur}
                    maxLength={255}
                    icon={value.userIcon}
                />
            </Grid>
        </Grid>
    );
};

export default FormRecovery;